import React from 'react';

// كرت العرض، تقدرون تحطون فيه صورة، عنوان، ووصف، وبياخذ تنسيق الموقع تلقائياً
export default function Card({ image, title, description, children, className = "" }) {
  return (
    <div className={`card-container ${className}`}>
      {/* إذا فيه صورة بتظهر هنا */}
      {image && <img src={image} alt={title} className="card-img" />}
      
      <div className="card-body">
        {/* العنوان والوصف حسب الحاجة */}
        {title && <h3 className="card-title">{title}</h3>}
        {description && <p className="card-text">{description}</p>}
        
        {/* هنا لو احد يبي يضيف أزرار أو محتوى زيادة داخل الكرت */}
        {children}
      </div>
    </div>
  );
}